import { appendReduxParts } from "infrastructure/store";

import PlexTranslationMessagesManager from "./PlexTranslationMessages";
import { plexTranslationMessagesManagerSaga } from "./PlexTranslationMessages.saga";
import { plexTranslationMessagesManager } from "./PlexTranslationMessages.slice";
import { plexTranslationUploadSaga } from "./upload/PlexTranslationUpload.saga";
import { plexTranslationUploadManager } from "./upload/PlexTranslationUpload.slice";

export * from "./PlexTranslationMessages.slice";
export { PlexTranslationMessagesManager };

appendReduxParts(
  [
    {
      reducerName: plexTranslationMessagesManager.name,
      reducer: plexTranslationMessagesManager.reducer
    },
    {
      reducerName: plexTranslationUploadManager.name,
      reducer: plexTranslationUploadManager.reducer
    }
  ],
  [plexTranslationMessagesManagerSaga(), plexTranslationUploadSaga()]
);
